export default "__VITE_ASSET__x3mbpD5G__"